<template>
  <section class="container-fluid bg-white">
    <Table
      :data="usergroups || []"
      :columns="table.columns"
      :actions="table.actions"
      :actionButton="table.actionButton"
      :disableSearch="false"
      :search="table.search"
      @rowClicked="table.clickHandler"
    />
  </section>
</template>

<script>
export default {
  data () {
    return {
      usergroups: [],
      table: {
        columns: [
          {
            label: 'Name',
            property: 'name',
            searchable: true,
            sort: { enabled: true, default: true }
          },
          {
            label: 'Description',
            property: 'description',
            searchable: true,
            sort: { enabled: true }
          }
        ],
        actions: [
          { icon: 'fas fa-trash-alt', buttonClass: 'btn-danger', action: this.deleteItem }
        ],
        actionButton: {
          icon: 'fa fa-plus',
          label: 'Create new user group',
          action: () => this.$router.push({ name: 'UsergroupCreate' })
        },
        clickHandler: (item) => this.$router.push('/usergroups/' + item.id),
        search: {
          placeholder: 'Search user groups',
          disabled: false
        }
      }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.$store
        .dispatch('getUsergroups')
        .then(response => {
          this.usergroups = response
          this.isLoading = false
        }).catch(error => {
          this.isLoading = false
          this.$swal({
            title: 'Error',
            text: 'Could not fetch usergroups: ' + error,
            icon: 'error'
          })
        })
    },
    deleteItem (item, index) {
      this
        .$swal({
          title: 'Are you really sure?',
          text: 'The usergroup "' + item.name + '" will be deleted. This cannot be undone!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          confirmButtonColor: '#dd4b39',
          cancelButtonText: 'Cancel'
        })
        .then(
          result => {
            if (result.value) {
              this.isLoading = true
              const data = {
                item: item
              }
              this.$store
                .dispatch('deleteUsergroup', data)
                .then(response => {
                  this.usergroups.splice(index, 1)
                  this.$swal({
                    title: 'Success',
                    text: 'Module "' + item.name + '" has been deleted',
                    icon: 'success',
                    showConfirmButton: false,
                    toast: true,
                    position: 'top',
                    timer: 2000
                  })
                  this.isLoading = false
                }).catch(error => {
                  this.isLoading = false
                  this.error = true
                  this.$swal({
                    title: 'Error',
                    text: 'could not delete usergroup: ' + error,
                    icon: 'error'
                  })
                })
            }
          }
        )
    }
  }
}
</script>
